import styled from 'styled-components';

import Button from '_components/_core/Button';

export const StyledButton = styled(Button)`
  padding: 0 !important;
`;
